import { render } from "./MultitokenCard.vue?vue&type=template&id=7c3558c7&scoped=true"
import script from "./MultitokenCard.vue?vue&type=script&lang=js"
export * from "./MultitokenCard.vue?vue&type=script&lang=js"

import "./MultitokenCard.vue?vue&type=style&index=0&id=7c3558c7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c3558c7"]])

export default __exports__